export const timerReducer = (state = false, action) => {
    switch (action.type) {
        case "SET_START_TIMER":
            return true;
        case "SET_STOP_TIMER":
            return false;
        default:
            return state;
    }

};
